import { theme } from 'lib';
import styled from 'styled-components';

const StyledTd = styled.td`
  background-color: ${(props) => (props.isSelected ? theme.GREY_10 : 'transparent')};
  border-bottom: ${(props) => (props.noBorder ? '0' : '1px solid #ddd')};
  padding: 8px;
  /* Opt-in: centers inline and inline-block cell content. Off by default so every existing
     admin table keeps its left-aligned columns. */
  text-align: ${(props) => (props.center ? 'center' : 'initial')};
  vertical-align: ${(props) => props.valign || 'initial'};
  width: ${(props) => props.wid || 'auto'};
  ${(props) => props.first && `padding-left: 24px;`}
  ${(props) => props.last && `padding-right: 24px;`}
`;

export default StyledTd;
